import PercentageSlider from './PercentageSlider';
import {Box, Stack, Typography} from '@mui/material';
import ArrAccordionWithCheckbox from '../../common/arr-accordion-with-checkbox/ArrAccordionWithCheckbox';
import {t} from 'i18next';
import Folders from './Folders';
import SavedSearchResultsSets from './SavedSearchResultsSets';
import ProductionSets from './ProductionSets';
import Assignments from './Assignments';
import {useCorpusContext} from '../ViewCategorization';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../assets/images/info-icon.svg';
import {numberFormatter} from '../../../utils/utils';
import {useMemo} from 'react';

function getPrimaryText(contextsSet: any, text1: string, text2: string) {
  return (
    <Stack direction="row" gap={0.5}>
      <Typography
        className="typo-text subhead5_size"
        data-testid={`corpus-${text1}-primary`}
      >
        {text1}
      </Typography>
      {contextsSet?.find((context: any) => context.type === text2)
        ?.contextIds && (
        <Typography
          className="typo-text body3_size"
          data-testid={`corpus-${text1}-secondary`}
        >
          (
          {numberFormatter.format(
            contextsSet?.find((context: any) => context.type === text2)
              ?.contextIds.length
          )}
          )
        </Typography>
      )}
    </Stack>
  );
}
const Corpus = () => {
  const {cohesion, setCohesion, analysisSetContexts} = useCorpusContext();
  const sections = [
    {
      id: t('corpus.sectionType.folders'),
      title: {
        primaryText: getPrimaryText(
          analysisSetContexts,
          t('corpus.folders'),
          t('corpus.sectionType.folders')
        ),
        secondaryText: '',
      },
      content: <Folders />,
      checked: false,
      showCheckbox: false,
    },
    {
      id: t('corpus.sectionType.assignments'),
      title: {
        primaryText: getPrimaryText(
          analysisSetContexts,
          t('corpus.assignments'),
          t('corpus.sectionType.assignments')
        ),
        secondaryText: '',
      },
      content: <Assignments />,
      checked: false,
      showCheckbox: false,
    },
    {
      id: t('corpus.sectionType.savedSearchResultsSets'),
      title: {
        primaryText: getPrimaryText(
          analysisSetContexts,
          t('corpus.savedSearchResultsSets'),
          t('corpus.sectionType.savedSearchResultsSets')
        ),
        secondaryText: '',
      },
      content: <SavedSearchResultsSets />,
      checked: false,
      showCheckbox: false,
    },
    {
      id: t('corpus.sectionType.productionSets'),
      title: {
        primaryText: getPrimaryText(
          analysisSetContexts,
          t('corpus.productionSets'),
          t('corpus.sectionType.productionSets')
        ),
        secondaryText: '',
      },
      content: <ProductionSets />,
      checked: false,
      showCheckbox: false,
    },
  ];
  const multipleExtendedSections = useMemo(() => {
    return analysisSetContexts
      ? analysisSetContexts.map((context) => context.type)
      : [];
  }, [analysisSetContexts]);
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box
        className="typo-text subhead4_size Step1-title corpus-title"
        aria-label={t('corpus.select')}
        data-testid="vc-view-categorization-title"
      >
        <span tabIndex={0}>{t('corpus.select')}</span>

        <Box paddingLeft={1} display="flex" alignItems="center">
          <ArrTooltipWrapper
            title={t('corpus.toolTipHeading1')}
            threshold={1}
            trigger={
              <InfoIcon
                fontSize="medium"
                className="info-icon-small"
                data-testid="step2-tooltip-info"
                tabIndex={0}
                aria-label={t('corpus.labelSelectCorpus')}
              />
            }
          >
            <div data-testid="step2Tooltip-content">
              <p
                dangerouslySetInnerHTML={{
                  __html: t('corpus.toolTipContent1'),
                }}
                data-testid={`corpus-p`}
              />
            </div>
          </ArrTooltipWrapper>
        </Box>
      </Box>
      <Box className="scrollable-content">
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-around'}
          gap={1}
          marginY={0.5}
          className="step1-dropdownBox"
          flexDirection={{xs: 'column', md: 'row'}}
        >
          <Box display={'flex'} alignItems={'center'} gap={0.5}>
            <Typography tabIndex={0} data-testid={`corpus-cohesion`}>
              {t('corpus.cohesion')}
            </Typography>
            <ArrTooltipWrapper
              title={t('corpus.toolTipHeading')}
              trigger={
                <InfoIcon
                  fontSize="medium"
                  className="info-icon-small"
                  data-testid="step2-tooltip-info"
                  tabIndex={0}
                  aria-label={t('corpus.lableCohesionInfoIcon')}
                />
              }
            >
              <div data-testid="step2Tooltip-content">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('corpus.toolTipContent'),
                  }}
                  data-testid={`corpus-p-text`}
                />
              </div>
            </ArrTooltipWrapper>
          </Box>
          <PercentageSlider value={cohesion} onChange={setCohesion} />
        </Box>
        <ArrAccordionWithCheckbox
          allowMultiple
          sections={sections}
          multipleExtendedSections={multipleExtendedSections}
        />
      </Box>
    </Box>
  );
};

export default Corpus;
